(function ($) {
  var changeNews = 0;
  function getAjax(offset) {
    if (changeNews == 1) {
      return;
    }

    changeNews = 1;
    $.ajax({
      url: $('#btn_actu').data('ajax'),
      type: "GET",
      data: {
        'action': 'get_actu',
        'offset': offset,
      }
    }).done(function (response) {
      changeNews = 0;
      var offset = parseInt($('#btn_actu').data('offset'));
      offset += $(response).find('.news-listing__item').length;
      if (offset >= $('#btn_actu').data('max')) {
        $('#btn_actu').hide();
      }
      $('#btn_actu').data('offset', offset);
      $('.news-listing__list').append(response);
    });
  }
  $(function () {
    $('#btn_actu').on('click', function () {
      var offset = $(this).data('offset');
      getAjax(offset);
    });
  });
})(jQuery);
